export default __webpack_public_path__ + "static/media/FrankRuhlLibre-Medium.c2c192d2.ttf";